import React, { useState } from "react";
import direction from "../../images/Contact/direction.svg";
import experts from "../../images/Contact/experts.svg";
import nospam from "../../images/Contact/no-spam.svg";
import "../../Style/Contact/Contact.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Form = ({ setExpertForm, whiteBg = false, nyeMode = false, customiseMode = false }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [showOtherInput, setShowOtherInput] = useState(false); // 👈 ADD THIS LINE HERE

  const location = useLocation();
const isTripPage = location.pathname.includes("/trip/");
const isCustomiseTripPage = location.pathname === "/customise-trip" || customiseMode;
const isAdsPage = location.pathname === "/landing-page-domestic-trips"||
  location.pathname === "/landing-page-international-trips" ||
  location.pathname === "/landing-page-nye-trips"||
  location.pathname === "/landing-page-nye-domestic-trips"||
  location.pathname === "/landing-page-all-trips"
  ||
  location.pathname === "/landing-page-nye-international-trips"  ||
  location.pathname === "/landing-page-ladakh-winter-trip" ||
  location.pathname === "/landing-page-summer-bike-trips"||
  location.pathname === "/landing-page-ladakh-summer-trip-2026"||
  location.pathname === "/landing-page-kashmir-winter-trip"||
    location.pathname === "/newyear-trips";



const handleChange = (e) => {
  const { name, value } = e.target;

  // ✅ Allow only 10 digits in phone number
  if (name === "phone") {
    if (value.length > 10) return; // Stop if more than 10 digits
    if (!/^\d*$/.test(value)) return; // Allow only numbers
  }

  setForm({ ...form, [name]: value });
};

  const submitHandler = async (e) => {
    e.preventDefault();
    let messageString = form.message || "";

if (isCustomiseTripPage) {
  messageString = `
From: ${form.from || "-"}
Destination: ${form.to || "-"}
Travel Dates: ${form.fromDate || "-"} to ${form.toDate || "-"}
Duration: ${form.duration || "-"}
Total People: ${form.totalPeople || "-"}
Budget: ${form.budget || "-"}
Hotel Category: ${form.hotelCategory || "-"}
Travel Mood: ${form.travelMood || "-"}
Important Points: ${form.notes || "-"}
  `;
} else if (isAdsPage) {
  // ✅ Add all NYE / Landing page details here
  messageString = `
Trip Type: ${form.type || "-"}
Travel When: ${(form.travelWhen || []).join(", ") || "-"}
Destination: ${form.message || "-"}
  `;
}



    setLoading(true);
    axios({
      method: "POST",
      data: {
        name: form.name,
        phone: form.phone,
        email: form.email,
message: messageString,      },
      withCredentials: true,
url: `/api/inquiry/add-inquiry`,
    })
      .then((res) => {
        setTimeout(() => {
          setLoading(false);
        }, 1500);
       if (res.data.success) {
  setTimeout(() => {
    setLoading(false);
  }, 1500);

  message.success(res.data.message);

  // Close expert form if open
  if (setExpertForm) setExpertForm(false);

  // ✅ Redirect to Thank You page only for NYE Trips
  if (location.pathname === "/nye-trips" || nyeMode) {
    navigate("/thank-you");
  }
}

      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

 return (
  <>
    {/* NYE TRIPS SPECIAL FORM DESIGN */}
{isAdsPage ? (
  <div className="ads-form-wrapper ads-form-page d-flex justify-content-center align-items-center my-5">

    <div className="nye-form-card shadow-lg p-4 rounded-4">
      <h3 className="nye-main-heading text-center mb-3">NYE Trips</h3>
     <p className="nye-subtext text-center mb-4 lp-subtext">
  The tribe’s filling up — join before it’s gone
</p>


      <form onSubmit={submitHandler}>
        {/* ✅ Name */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Name</label>
          <div className="border rounded-3 p-2">
            <input
              required
              name="name"
              onChange={handleChange}
              type="text"
              className="form-control border-0"
              placeholder="Enter your name"
            />
          </div>
        </div>

        {/* ✅ Phone */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Phone Number</label>
          <PhoneInput
            country={'in'}
            value={form.phone || ""}
            onChange={(phone, data) =>
              setForm({ ...form, phone: phone, countryCode: `+${data.dialCode}` })
            }
            inputProps={{ name: "phone", required: true }}
            containerStyle={{ width: "100%" }}
            inputStyle={{
              width: "100%",
              height: "50px",
              borderRadius: "10px",
              border: "1px solid #ced4da",
              fontSize: "16px",
            }}
          />
        </div>

        {/* ✅ Email */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Email</label>
          <div className="border rounded-3 p-2">
            <input
              required
              name="email"
              onChange={handleChange}
              type="email"
              className="form-control border-0"
              placeholder="Enter your email"
            />
          </div>
        </div>

        {/* ✅ When would you like to travel */}
       {/* ✅ When would you like to travel */}
<div className="mb-3">
  <label className="form-label fw-semibold">When would you like to travel?</label>
  <div className="travel-when-row">
    {["New Year", " Within 15 Days", "Within 30 Days", "30+ Days"].map((option) => (
      <div key={option} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          value={option}
          id={option}
          onChange={(e) => {
            let updated = form.travelWhen || [];
            if (e.target.checked) {
              updated = [...updated, option];
            } else {
              updated = updated.filter((x) => x !== option);
            }
            setForm({ ...form, travelWhen: updated });
          }}
        />
        <label className="form-check-label" htmlFor={option}>
          {option}
        </label>
      </div>
    ))}
  </div>
</div>


        {/* ✅ Trip Type */}
        <div className="mb-3">
          <label className="form-label fw-semibold">WOULD YOU LIKE TO TRAVEL IN A GROUP OR PRIVATELY</label>
          <select
            required
            name="type"
            onChange={handleChange}
            className="form-control"
            defaultValue=""
          >
            <option value="" disabled>Select Type</option>
            <option>Group Trip</option>
            <option>Customized Trip</option>
          </select>
        </div>

        {/* ✅ Destination */}
        <div className="mb-3">
          <label className="form-label fw-semibold">WHERE WOULD YOU LIKE TO TRAVEL</label>
          <select
            required
            name="message"
            onChange={(e) => {
              handleChange(e);
              setShowOtherInput(e.target.value === "Other");
            }}
            className="form-control"
            defaultValue=""
          >
            <option value="" disabled>Select Destination</option>
            <option value="Bali">Bali</option>
            <option value="Koh Samui">Koh Samui</option>
            <option value="Ladakh">Ladakh</option>
            <option value="Kashmir">Kashmir</option>
            <option value="Philippines">Philippines</option>
            <option value="Other">Other</option>
          </select>
          {showOtherInput && (
            <input
              required
              name="message"
              onChange={handleChange}
              type="text"
              className="form-control mt-2"
              placeholder="Enter your destination"
            />
          )}
        </div>

        {/* ✅ Submit button */}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-warning fw-bold px-5 rounded-pill">
            Talk to Trip Expert
          </button>
        </div>
      </form>
    </div>
  </div>


) : location.pathname === "/nye-trips" || nyeMode ? (
  // 🔵 Keep existing NYE form here as it is
      <div className="nye-form-wrapper d-flex justify-content-center align-items-center my-5">
        <div className="nye-form-card shadow-lg p-4 rounded-4">
<h3 className="nye-main-heading">
  {location.pathname.includes("/trip/") ? "Plan Your Trip" : "NYE Trips"}
</h3>
<p className="nye-subtext mt-2 mb-3">
  {isTripPage
    ? "Can’t decide where to head next? Let our travel experts craft your perfect getaway – whether it’s beaches, mountains, or beyond! Fill out the form below and we’ll design a trip that fits your vibe, budget, and tribe."
    : "Can’t decide where to ring in the New Year? Let our travel experts craft the perfect getaway – whether it’s Thailand, Bali, or the mountains! Fill out the form below and we’ll design a trip that fits your vibe, budget, and tribe."
  }
</p>



          <form onSubmit={submitHandler}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label fw-semibold">
                Name
              </label>
              <input
                required
                name="name"
                onChange={handleChange}
                type="text"
                className="form-control"
                maxLength={50}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone" className="form-label fw-semibold">
                Phone Number
              </label>
              <PhoneInput
  country={'in'} // Default India
  value={form.phone || ""}  // ✅ Bind only phone for full number
  onChange={(phone, data) => {
    setForm({
      ...form,
      phone: phone, // ✅ Store full number including country code
      countryCode: `+${data.dialCode}` // ✅ Optional: store separately if needed for backend
    });
  }}
  countryCodeEditable={false} // ✅ Prevent manual typing in country box
  inputProps={{
    name: 'phone',
    required: true,
  }}
  containerStyle={{ width: "100%" }}
  inputStyle={{ width: "100%", height: "45px", fontSize: "16px" }}
/>
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label fw-semibold">
                Email
              </label>
              <input
                required
                name="email"
                onChange={handleChange}
                type="email"
                className="form-control"
              />
            </div>

  <div className="mb-4">
  <label htmlFor="message" className="form-label fw-semibold">
    Destination
  </label>

  {location.pathname === "/nye-trips" ? (
    // ✅ Show dropdown only on NYE Trips page
    <select
      required
      name="message"
      onChange={handleChange}
      className="form-control"
      defaultValue=""
    >
      <option value="" disabled>Select Destination</option>
      <option value=" Pre NYE Bali"> Pre NYE Bali</option>
      <option value="NYE Koh Samui">NYE Koh Samui</option>
      <option value="NYE Ladakh">NYE Ladakh</option>
      <option value="NYE Kashmir">NYE Kashmir</option>
      <option value="NYE Philippines">NYE Philippines</option>
    </select>
  ) : (
    // ✅ Default text input for all other pages (including singletrip and itinerary)
    <input
      required
      name="message"
      onChange={handleChange}
      type="text"
      className="form-control"
      maxLength={299}
    />
  )}
</div>



            <div className="text-center">
              <button type="submit" className="btn btn-warning fw-bold px-5 rounded-pill">
                {loading
    ? "Loading..."
    : location.pathname === "/landing-page-all-trips"
    ? "Schedule Your Callback"
    : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    ) : (
      // 🧾 Default form layout for all other pages
      <div className="contact__form container rounded my-lg-5 my-3">
        <div className="row">
          {location.pathname !== "/contact" && setExpertForm && (
            <i
              onClick={() => setExpertForm(false)}
              className="form__icon text-danger text-center fa-solid fa-xmark"
            ></i>
          )}

          <div
            className={`${
              location.pathname === "/contact"
                ? "col-12 col-sm-6 col-md-6 col-lg-6 Mon_font px-lg-5 px-sm-2"
                : "col-12 col-sm-12 col-md-12 col-lg-12 px-lg-5 px-sm-2 py-lg-3"
            }`}
          >
      <h3 className="form__heading text-center fw-bold my-3">
  {isCustomiseTripPage ? (
    <>Hey <span className="text-warning">Traveller!</span></>
  ) : location.pathname.includes("/trip/") ? (
    <>
      Plan Your <span className="text-warning"> Trip</span>
    </>
  ) : (
    <>
      Want us to help you better?
      <br />
      <span className="text-warning">Connect with us </span>Right Away!
    </>
  )}
</h3>
{isCustomiseTripPage && (
  <p className="text-center mb-3">
    Ready to turn your travel dreams into reality? Just share your vibe, preferences, and a few quick details below,
    and our team at High Mountains will craft a personalised trip plan — made specially for you (and your travel tribe)!
  </p>
)}

            <hr className="px-5 mx-4" />

           <form
  className="px-5 py-4 rounded shadow-sm customise-trip-form"
  style={{
    backgroundColor:
      whiteBg || location.pathname !== "/contact" ? "#fff" : "transparent",
  }}
  onSubmit={submitHandler}
>

           {!isCustomiseTripPage && (
  <>
    <div className="mb-1 mb-lg-3">
      <label htmlFor="name" className="form-label">Name</label>
      <input
        required
        name="name"
        onChange={handleChange}
        type="text"
        className="form-control"
        maxLength={50}
      />
    </div>

    <div className="mb-1 mb-lg-3">
      <label htmlFor="phone" className="form-label">Phone Number</label>
      <PhoneInput
        country={'in'}
        value={form.phone || ""}
        onChange={(phone, data) => {
          setForm({ ...form, phone: phone, countryCode: `+${data.dialCode}` });
        }}
        countryCodeEditable={false}
        inputProps={{ name: 'phone', required: true }}
        containerStyle={{ width: "100%" }}
        inputStyle={{ width: "100%", height: "45px", fontSize: "16px" }}
      />
    </div>

    <div className="mb-1 mb-lg-3">
      <label htmlFor="email" className="form-label">Email</label>
      <input
        required
        name="email"
        onChange={handleChange}
        type="email"
        className="form-control"
      />
    </div>
  </>
)}


           {/* ✅ Only show Destination/Message input if NOT customise-trip page */}
{!isCustomiseTripPage && (
  <div className="mb-1 mb-lg-3">
    <label htmlFor="message" className="form-label">
      {location.pathname === "/contact" ? "Message" : "Destination/Message"}
    </label>
    <input
      required
      name="message"
      onChange={handleChange}
      type="text"
      className="form-control"
      maxLength={299}
    />
  </div>
)}

{isCustomiseTripPage && (
  <>
    <div className="row">
      {/* Name & Phone */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Name</label>
        <input
          required
          name="name"
          onChange={handleChange}
          type="text"
          className="form-control"
          maxLength={50}
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Phone Number</label>
        <PhoneInput
          country={'in'}
          value={form.phone || ""}
          onChange={(phone, data) => {
            setForm({ ...form, phone: phone, countryCode: `+${data.dialCode}` });
          }}
          countryCodeEditable={false}
          inputProps={{ name: 'phone', required: true }}
          containerStyle={{ width: "100%" }}
          inputStyle={{ width: "100%", height: "45px", fontSize: "16px" }}
        />
      </div>

      {/* Email full width */}
      <div className="col-12 mb-3">
        <label className="form-label fw-semibold">Email</label>
        <input
          required
          name="email"
          onChange={handleChange}
          type="email"
          className="form-control"
        />
      </div>

      {/* From & Destination */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">From</label>
        <input
          required
          name="from"
          onChange={handleChange}
          type="text"
          className="form-control"
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">To (Destination)</label>
        <input
          required
          name="to"
          onChange={handleChange}
          type="text"
          className="form-control"
        />
      </div>

      {/* Travel Date (Single Input) & Mood */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold"> Travel Date</label>
        <input
          required
          name="fromDate"
          onChange={handleChange}
          type="date"
          className="form-control"
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Travel Mood</label>
        <select
          required
          name="travelMood"
          onChange={handleChange}
          className="form-control"
          defaultValue=""
        >
          <option value="" disabled>Select Mood</option>
          <option>Adventure</option>
          <option>Romantic</option>
          <option>Family</option>
          <option>Chill</option>
          <option>Cultural</option>
          <option>Party</option>
          <option>Spiritual</option>
          <option>Solo</option>
          <option>Luxury</option>
        </select>
      </div>

      {/* Duration & Travellers */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Duration</label>
        <select
          required
          name="duration"
          onChange={handleChange}
          className="form-control"
          defaultValue=""
        >
          <option value="" disabled>Select Duration</option>
          <option value="2N/3D">2N/3D</option>
          <option value="3N/4D">3N/4D</option>
          <option value="4N/5D">4N/5D</option>
          <option value="5N/6D">5N/6D</option>
          <option value="6N/7D">6N/7D</option>
          <option value="7N/8D">7N/8D</option>
          <option value="8N/9D">8N/9D</option>
          <option value="9N/10D">9N/10D</option>
          <option value="10N/11D">10N/11D</option>
          <option value="11N/12D">11N/12D</option>
          <option value="12N/13D">12N/13D</option>
          <option value="14+">14+</option>
        </select>
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Total Travellers</label>
        <input
          required
          name="totalPeople"
          onChange={handleChange}
          type="number"
          className="form-control"
          min={1}
        />
      </div>

      {/* Budget & Hotel */}
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Budget (Per Person)</label>
        <input
          required
          name="budget"
          onChange={handleChange}
          type="number"
          className="form-control"
          min={0}
        />
      </div>
      <div className="col-md-6 mb-3">
        <label className="form-label fw-semibold">Hotel Category</label>
        <select
          required
          name="hotelCategory"
          onChange={handleChange}
          className="form-control"
          defaultValue=""
        >
          <option value="" disabled>Select Category</option>
          <option>3-Star</option>
          <option>4-Star</option>
          <option>5-Star</option>
          <option>Premium</option>
          <option>Exclusive Boutique</option>
        </select>
      </div>

      {/* Notes */}
      <div className="col-12 mb-3">
        <label className="form-label fw-semibold">Important Notes / Preferences</label>
        <textarea
          name="notes"
          onChange={handleChange}
          className="form-control"
          rows={3}
        />
      </div>
    </div>
  </>
)}

              <div className="text-center my-2">
                <button type="submit" className="btn btn-success">
                  {loading ? "Loading..." : "Submit"}
                </button>
                {isCustomiseTripPage && (
  <p className="text-center text-muted mt-3">
    Once you hit ‘Get My Plan’, our team will get back to you with a tailor-made itinerary,
    costing, and expert recommendations — all curated by High Mountains.
  </p>
)}

              </div>
            </form>
          </div>
        </div>
      </div>
    )}
  </>
);
};
export default Form;
